<template>
    <div>
        <common-table :url="url" :table-columns="tableColumns" :form-fields="formFields" :operate="operate" :permission="permission" :searchs="searchs" ref="table"></common-table>
    </div>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";

    export default {
        name: "OrderError",
        components: {CommonTable},
        data(){
            return{
                searchs:[
                    {
                        name: 'orderNo',
                        placeholder: '订单号',
                        type: 'input'
                    },
                    {
                        name: 'username',
                        placeholder: '用户名',
                        type: 'input'
                    },
                    {
                        name: 'status',
                        placeholder: '订单状态',
                        type: 'select',
                        selectValue:[
                            {
                                key: "1",
                                value: "成功"
                            },
                            {
                                key: "4",
                                value: "未处理"
                            },{
                                key: 5,
                                value: '处理中'
                            },{
                                key: 6,
                                value: '关闭'
                            }
                        ]
                    },
                    {
                        name: 'startTime',
                        placeholder: '开始时间',
                        type: 'dateTime'
                    },
                    {
                        name: 'endTime',
                        placeholder: '结束时间',
                        type: 'dateTime'
                    }
                ],
                permission:{
                    add: 'orderTimeoutError:add',
                    update: 'orderTimeoutError:update',
                    delete: 'orderTimeoutError:delete',
                    deleteBatch: 'orderTimeoutError:deleteBatch'
                },
                url: {
                    get: '/orderTimeoutError/listByCondition',
                    //add: '/order/add',
                    //update: '/order/update',
                    //delete: '/order/delete/',
                    //delete_batch: '/order/deleteBatch',
                },
                tableColumns: [{
                    field: 'id',
                    label: 'ID',
                    show: true,
                    width: '75',
                },{
                    field: 'orderNo',
                    label: '订单号',
                    show: true,
                    width: '',
                },{
                    field: 'userNick',
                    label: '用户昵称',
                    show: true,
                    width: '',
                }/*,{
                    field: 'taskTypeId',
                    label: '任务类型',
                    show: true,
                    width: '',
                }*/,{
                    field: 'status',
                    label: '状态',
                    show: {
                        type: 'tag',
                        tags: [{
                            key: 1,
                            value: '成功',
                            type: 'success'
                        },{
                            key: 0,
                            value: '处理失败',
                            type: 'warning'
                        }]
                    },
                    width: '',
                },{
                    field: 'failCause',
                    label: '失败原因',
                    show: true,
                    width: '',
                },{
                    field: 'updateNick',
                    label: '修改人',
                    show: true,
                    width: '',
                },{
                    field: 'grabTime',
                    label: '抢单时间',
                    show: true,
                    width: '',
                },{
                    field: 'completeTime',
                    label: '完成时间',
                    show: true,
                    width: '',
                }],
                formFields: {
                    addTitle: '添加订单',
                    updateTitle: '修改订单',
                    labelWidth: '105px',
                    model: [],
                },
                operate: [],
            }
        }
    }
</script>

<style scoped>

</style>
